import { useRef, useState } from "react";
import { GameStates } from "../utils/constants";
import { QuestionTypes } from "../utils/types";

export function useInGameMessages() {
    const timeoutRef = useRef(null);
    const [inGameMessage, setInGameMessage] = useState(null);

    const changeInGameMessage = (game, hideAfter = 0) => {
        let message = "";
        switch (game?.state) {
            case GameStates.WELCOME:
                message = "¡Es momento de aprender jugando! ¡Comencemos!";
                break;
            case GameStates.SPINNER:
                if (game.applyJoker === false) {
                    switch (game.current_question.cardType) {
                        case QuestionTypes.CONOCIMIENTO:
                            message = "¡Hora de un Desafío de Conocimiento!";
                            break;
                        case QuestionTypes.CREATIVIDAD:
                            message = "¡Hora de un Desafío Creativo!";
                            break;
                        case QuestionTypes.TALENTO:
                            message = "¡Hora de un Desafío de Talento!";
                            break;
                    }
                } else {
                    message = "¡Comodín! Un viajero al azar elegirá el siguiente desafío.";
                }
                break;
        }
        if (!message) return;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setInGameMessage(message);
        timeoutRef.current = setTimeout(() => {
            setInGameMessage(null);
            clearTimeout(timeoutRef.current);
        }, hideAfter);
    }

    const clearInGameMessage = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setInGameMessage(null);
    }

    return {
        inGameMessage,
        changeInGameMessage,
        clearInGameMessage
    };

}